import type { ReactNode } from "react";

import { Stack } from "@mui/material";
import Chip from "components/Chip";

export type ResultChipOption = {
  label?: ReactNode;
  name: string;
};

type TransientJobResultScenarioChipsProps = {
  activeKey: string;
  label?: ReactNode;
  onSelect: (key: string) => void;
  options: ResultChipOption[];
};

export const TransientJobResultScenarioChips = ({
  activeKey,
  label,
  onSelect,
  options,
}: TransientJobResultScenarioChipsProps) => {
  if (options.length === 0) return null;
  return (
    <Stack className="flex-wrap gap-2">
      {label ? <span className="font-ds-body-regular-md">{label}</span> : null}
      {options.map((option) => (
        <Chip isOn={activeKey === option.name} key={option.name} onClick={() => onSelect(option.name)}>
          {option.label ?? option.name}
        </Chip>
      ))}
    </Stack>
  );
};
